<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <div
          class="input-group input-prepend input-append"
          v-for="(file, index) in files"
          :key="index"
        >
          <div class="input-file input-add">
            <input type="file" @change="onFileChange($event, index)" />
            <label class="custom-file-label">{{
              file.fileName ? file.fileName : "Choose file"
            }}</label>
          </div>
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addFile(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteFile(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add File</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
export default {
  components: {
    spinnerButton,
  },
  props: ["submitLoading"],
  data() {
    return {
      files: [{ file: null, fileName: null }],
    };
  },
  methods: {
    onFileChange: function (event, index) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      this.files[index].file = file;
      this.files[index].fileName = file.name;
    },
    buttonClick: function () {
      this.$emit("buttonClick", this.files);
    },
    addFile: function (index) {
      this.files.splice(index + 1, 0, { file: null, fileName: null });
    },
    deleteFile: function (index) {
      this.files.splice(index, 1);
      if (this.files.length == 0) {
        this.files.push({ file: null, fileName: null });
      }
    },
  },
};
</script>
